/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { DateRequest } from '../models';
/**
 * DateApi - axios parameter creator
 * @export
 */
export const DateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Allow Anonymous | Returns current date time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DateGetBaseDateGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Date/GetBaseDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tester | Set Current Date \"yyyy-MM-dd\"
         * @param {DateRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DateSetCurrentDatePost: async (body?: DateRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Date/SetCurrentDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DateApi - functional programming interface
 * @export
 */
export const DateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Allow Anonymous | Returns current date time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2DateGetBaseDateGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Date>> {
            const localVarAxiosArgs = await DateApiAxiosParamCreator(configuration).apiV2DateGetBaseDateGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Tester | Set Current Date \"yyyy-MM-dd\"
         * @param {DateRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2DateSetCurrentDatePost(body?: DateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Date>> {
            const localVarAxiosArgs = await DateApiAxiosParamCreator(configuration).apiV2DateSetCurrentDatePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DateApi - factory interface
 * @export
 */
export const DateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Allow Anonymous | Returns current date time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DateGetBaseDateGet(options?: any): AxiosPromise<Date> {
            return DateApiFp(configuration).apiV2DateGetBaseDateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tester | Set Current Date \"yyyy-MM-dd\"
         * @param {DateRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DateSetCurrentDatePost(body?: DateRequest, options?: any): AxiosPromise<Date> {
            return DateApiFp(configuration).apiV2DateSetCurrentDatePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DateApi - object-oriented interface
 * @export
 * @class DateApi
 * @extends {BaseAPI}
 */
export class DateApi extends BaseAPI {
    /**
     * 
     * @summary Allow Anonymous | Returns current date time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DateApi
     */
    public apiV2DateGetBaseDateGet(options?: any) {
        return DateApiFp(this.configuration).apiV2DateGetBaseDateGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Tester | Set Current Date \"yyyy-MM-dd\"
     * @param {DateRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DateApi
     */
    public apiV2DateSetCurrentDatePost(body?: DateRequest, options?: any) {
        return DateApiFp(this.configuration).apiV2DateSetCurrentDatePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
